/* eslint-disable better-tailwindcss/no-conflicting-classes, better-tailwindcss/no-unknown-classes */
import React from 'react';

import { InfoIcon } from '@infinex/ui-icons';
import { Text } from '@infinex/ui/components';

export function MoreDetailsButton({
  className = '',
  onClick,
  text = 'Connection Request',
  icon,
}: {
  className?: string;
  onClick?: () => void;
  text?: string;
  icon: React.ReactElement;
}) {
  return (
    <div
      className={`group flex h-8 w-fit cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-2xl bg-[#452A22] px-3 outline outline-[4px] outline-[#101114] ${className}`}
      onClick={onClick}
    >
      {/* hover overlay driven by the parent group */}
      <div className="pointer-events-none absolute inset-0 rounded-2xl bg-[#FE6F39] opacity-0 transition-opacity duration-200 group-hover:opacity-40" />

      {/* content stays above */}
      <div className="relative z-10 flex items-center gap-2">
        {icon}
        <Text className="text-brand text-center text-xs font-semibold whitespace-nowrap">
          {text}
        </Text>
        <InfoIcon fill="brand" size="2xsmall" />
      </div>
    </div>
  );
}
